module.exports = __webpack_public_path__ + "static/media/chat.0234e502.png";